import React from 'react';
import { Facebook, Instagram, Youtube, ExternalLink } from 'lucide-react';
import { Card } from '../components/ui/card';
import { socialFeeds } from '../data/mock';

const Media = () => {
  // TONYMOLY Instagram Posts with actual images
  const tonymolyInstagramPosts = [
    {
      image: 'https://customer-assets.emergentagent.com/job_global-brands-mn/artifacts/zbm042gk_640688441_18344771809236386_6300787890708855687_n.jpg',
      url: 'https://www.instagram.com/reel/DVTJWqvD5Kd/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA=='
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_global-brands-mn/artifacts/niu1v3d6_641056081_18344774569236386_1910276188283148687_n.jpg',
      url: 'https://www.instagram.com/reel/DVTNErhj0nG/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA=='
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_global-brands-mn/artifacts/omhwc3f9_658743477_18350397757236386_6924038468508024754_n.jpg',
      url: 'https://www.instagram.com/p/DWvMdEvj6z_/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA=='
    }
  ];

  // Portmeirion Instagram Posts with actual images
  const portmeirionInstagramPosts = [
    {
      image: 'https://customer-assets.emergentagent.com/job_global-brands-mn/artifacts/2ru7yhu1_594535992_1325755209563920_9742405202766581_n.jpg',
      url: 'https://www.instagram.com/p/DR0xOcRErLP/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA=='
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_global-brands-mn/artifacts/pgezx792_593522507_1323653149774126_7646765373529791233_n.jpg',
      url: 'https://www.instagram.com/p/DRvlf-Mj0gt/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA=='
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_global-brands-mn/artifacts/viq18c95_658108320_18318512371254167_7846043189584583847_n.jpg',
      url: 'https://www.instagram.com/reel/DWv8s9eiEK0/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA=='
    }
  ];

  // Ecover Instagram Posts with actual images
  const ecoverInstagramPosts = [
    {
      image: 'https://customer-assets.emergentagent.com/job_global-brands-mn/artifacts/d53ehr85_532325576_17852033433515052_2990409090221647924_n.jpg',
      url: 'https://www.instagram.com/p/DNU94-BxJZJ/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA=='
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_global-brands-mn/artifacts/95q9fpyd_531920884_17851791288515052_1909142231961288859_n.jpg',
      url: 'https://www.instagram.com/p/DNP8I8ixXWr/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA=='
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_global-brands-mn/artifacts/b94m5gvp_516418067_122130081512731355_3218117169687274555_n.jpg',
      url: 'https://www.instagram.com/p/DL1k5GFvhgE/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA=='
    }
  ];

  const brandSocials = [
    {
      name: 'TONYMOLY Mongolia',
      description: 'Follow us for the latest Korean beauty trends, product launches, and skincare tips',
      facebook: 'https://www.facebook.com/TonyMolyMongolianDistributor',
      instagram: 'https://www.instagram.com/tonymoly.mn_official/',
      youtube: 'https://www.youtube.com/channel/UClcwJi4IJ8U3ImLqzeknZWQ',
      feeds: socialFeeds.tonymoly,
      color: 'from-pink-600 to-rose-600',
      hasRealPosts: true,
      brandKey: 'tonymoly'
    },
    {
      name: 'Portmeirion Mongolia',
      description: 'Discover elegant tableware, home inspiration, and lifestyle content',
      facebook: 'https://www.facebook.com/PortmeirionMongolia/',
      instagram: 'https://www.instagram.com/portmeirion.mongolia/',
      youtube: 'https://www.youtube.com/channel/UC_5TRm3e2ooocwqJ3IldqGg',
      feeds: socialFeeds.portmeirion,
      color: 'from-emerald-600 to-teal-600',
      hasRealPosts: true,
      brandKey: 'portmeirion'
    },
    {
      name: 'Ecover Mongolia',
      description: 'Stay updated on clean air solutions and sustainable living tips',
      facebook: 'https://www.facebook.com/profile.php?id=61571940673538',
      instagram: 'https://www.instagram.com/ecover.cleanair/',
      youtube: null,
      feeds: socialFeeds.ecover,
      color: 'from-blue-600 to-cyan-600',
      hasRealPosts: true,
      brandKey: 'ecover'
    }
  ];

  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="py-32 bg-black text-white">
        <div className="container mx-auto px-6 lg:px-12">
          <div className="max-w-4xl">
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold mb-6 leading-tight">
              Media & Social
            </h1>
            <p className="text-2xl md:text-3xl text-gray-300 leading-relaxed">
              Stay connected with our brands across social media
            </p>
          </div>
        </div>
      </section>

      {/* Brand Social Sections */}
      {brandSocials.map((brand, index) => (
        <section 
          key={brand.name}
          className={`py-24 ${index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}`}
        >
          <div className="container mx-auto px-6 lg:px-12">
            {/* Brand Header */}
            <div className="mb-12">
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
                {brand.name}
              </h2>
              <p className="text-xl text-gray-600 mb-6">
                {brand.description}
              </p>

              {/* Social Links */}
              <div className="flex flex-wrap gap-4">
                <a 
                  href={brand.facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center space-x-2 bg-black text-white hover:bg-gray-800 rounded-full px-6 py-3 font-semibold transition-all duration-300 hover:scale-105"
                >
                  <Facebook size={20} />
                  <span>Facebook</span>
                  <ExternalLink size={16} />
                </a>
                <a 
                  href={brand.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center space-x-2 bg-black text-white hover:bg-gray-800 rounded-full px-6 py-3 font-semibold transition-all duration-300 hover:scale-105"
                >
                  <Instagram size={20} />
                  <span>Instagram</span>
                  <ExternalLink size={16} />
                </a>
                {brand.youtube && (
                  <a 
                    href={brand.youtube}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center space-x-2 bg-black text-white hover:bg-gray-800 rounded-full px-6 py-3 font-semibold transition-all duration-300 hover:scale-105"
                  >
                    <Youtube size={20} />
                    <span>YouTube</span>
                    <ExternalLink size={16} />
                  </a>
                )}
              </div>
            </div>

            {/* Instagram Feed Section */}
            <div className="mb-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Latest from Instagram</h3>
              
              {/* Conditional Render: Real images for brands with posts, Mock for others */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {brand.hasRealPosts ? (
                  // Brands with real Instagram images
                  (() => {
                    let posts;
                    let iconColor;
                    
                    if (brand.brandKey === 'tonymoly') {
                      posts = tonymolyInstagramPosts;
                      iconColor = 'text-pink-600';
                    } else if (brand.brandKey === 'portmeirion') {
                      posts = portmeirionInstagramPosts;
                      iconColor = 'text-emerald-600';
                    } else if (brand.brandKey === 'ecover') {
                      posts = ecoverInstagramPosts;
                      iconColor = 'text-blue-600';
                    }
                    
                    return posts.map((post, index) => (
                      <a
                        key={index}
                        href={post.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="group block rounded-xl overflow-hidden border border-gray-200 hover:border-gray-300 transition-all duration-300 hover:shadow-xl hover:-translate-y-1"
                      >
                        <div className="aspect-square overflow-hidden bg-gray-100">
                          <img 
                            src={post.image} 
                            alt={`${brand.name} Instagram post ${index + 1}`}
                            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                          />
                        </div>
                        <div className="p-4 bg-white">
                          <p className="text-sm text-gray-600 flex items-center justify-between">
                            <span className="flex items-center gap-2">
                              <Instagram size={16} className={iconColor} />
                              View on Instagram
                            </span>
                            <ExternalLink size={14} className="text-gray-400" />
                          </p>
                        </div>
                      </a>
                    ));
                  })()
                ) : (
                  // Other brands: Mock placeholder cards
                  [1, 2, 3].map((index) => (
                    <a
                      key={index}
                      href={brand.instagram}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="group block bg-gradient-to-br from-purple-50 to-pink-50 rounded-xl overflow-hidden border border-gray-200 hover:border-gray-300 transition-all duration-300 hover:shadow-lg hover:-translate-y-1"
                    >
                      <div className="aspect-square bg-gradient-to-br from-gray-100 to-gray-50 flex items-center justify-center">
                        <Instagram className="w-16 h-16 text-gray-300 group-hover:text-gray-400 transition-colors" />
                      </div>
                      <div className="p-4 bg-white">
                        <p className="text-sm text-gray-600 flex items-center justify-between">
                          <span>View on Instagram</span>
                          <ExternalLink size={14} className="text-gray-400" />
                        </p>
                      </div>
                    </a>
                  ))
                )}
              </div>
            </div>
          </div>
        </section>
      ))}

      {/* CTA Section */}
      <section className="py-24 bg-black text-white">
        <div className="container mx-auto px-6 lg:px-12 text-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Connect with Our Brands
          </h2>
          <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto">
            Follow TONYMOLY, Portmeirion, and Ecover on social media for exclusive content, promotions, and updates
          </p>
        </div>
      </section>
    </div>
  );
};

export default Media;
